import { IconDeviceMobileVibration } from "@tabler/icons-react";
import NotifPrefRow from "./NotifPrefRow";
import { PUSH_NOTIF_PREFS } from "./data";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function PushNotificationsCard() {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div
            className={styles.cardIcon}
            style={{ background: "#fce8f3", color: "#e1306c" }}
          >
            <IconDeviceMobileVibration size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Push & In-App Notifications</div>
            <div className={styles.cardSubtitle}>
              Real-time alerts within the platform
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.notifPrefList}>
          {PUSH_NOTIF_PREFS.map((pref) => (
            <NotifPrefRow key={pref.id} pref={pref} />
          ))}
        </div>
      </div>
    </div>
  );
}
